import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import FairyBell from './components/fairy/FairyBell';
import LandingPage from './pages/LandingPage';
import Home from './pages/Home';
import AnimePage from './pages/AnimePage';
import Watch from './pages/Watch';
import Directory from './pages/Directory';
import MyList from './pages/MyList';
import Perfil from './pages/Perfil';
import Admin from './pages/Admin';
import SearchResults from './pages/SearchResults';

// ── Route guard ───────────────────────────────────────────────────────────────

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/" replace />;
}

// ── Suspension overlay ────────────────────────────────────────────────────────

function SuspensionOverlay() {
  const { suspension } = useAuth();
  if (!suspension?.active) return null;

  const expiresAt = suspension.expiresAt ? new Date(suspension.expiresAt) : null;
  const expiresStr = expiresAt
    ? expiresAt.toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' })
    : null;

  return (
    <div className="suspension-overlay">
      <div className="suspension-card">
        <h2>Cuenta suspendida</h2>
        <p>Se detectaron múltiples conexiones simultáneas desde distintas IPs.</p>
        {expiresStr && <p className="suspension-expires">La suspensión expira el {expiresStr}.</p>}
        <p className="suspension-contact">
          Si creés que es un error, contactá al administrador.
        </p>
      </div>
    </div>
  );
}

// ── App ───────────────────────────────────────────────────────────────────────

function AppInner() {
  const { user } = useAuth();
  return (
    <>
      {user && <Navbar />}
      {user && <SuspensionOverlay />}
      <FairyBell />
      <Routes>
        <Route path="/" element={
          user ? <Navigate to="/home" replace /> : <LandingPage />
        } />
        <Route path="/home" element={
          <PrivateRoute><Home /></PrivateRoute>
        } />
        <Route path="/directorio" element={
          <PrivateRoute><Directory /></PrivateRoute>
        } />
        <Route path="/anime/:id" element={
          <PrivateRoute><AnimePage /></PrivateRoute>
        } />
        <Route path="/watch/:episodeId" element={
          <PrivateRoute><Watch /></PrivateRoute>
        } />
        <Route path="/mi-lista" element={
          <PrivateRoute><MyList /></PrivateRoute>
        } />
        <Route path="/perfil" element={
          <PrivateRoute><Perfil /></PrivateRoute>
        } />
        <Route path="/search" element={
          <PrivateRoute><SearchResults /></PrivateRoute>
        } />
        <Route path="/admin" element={
          <PrivateRoute><Admin /></PrivateRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </AuthProvider>
  );
}
